import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterUser_template} from "./filterUser_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {downloadCSV} from "../../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
// import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {filterArticle_template} from "./filterArticle_template";


declare var ko: any;

export class accountingReportByUser_template extends vnTemplate{

    protected filterUser: filterUser_template;
    protected brandMenu: filterDropdown_template;
    public pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected dateFilter : multipleSelector_template;
    protected paymentMethodFilter : multipleSelector_template;
    protected roleFilter : multipleSelector_template;
    protected currencyFilter : multipleSelector_template;
    protected accountFilter: multipleSelector_template;
    protected validationsList: validationsList_template;
    protected filterPreset: filterPreset_template;

    protected getTemplateHtml(): string{

        return `
        <div class="sub-header filter-preset w-justify ">

                ` + this.filterPreset.getHtmlBuild() + `
        </div>

        <div id="main-container">
          
           <div class="sub-header w-justify"> 
                <div class="w-left">
                     ` + this.filterUser.getHtmlBuild() + `
                    <div><label class="form-label form-label-box">Brand</label>` + this.brandMenu.getHtmlBuild() + ` </div>
                     ${this.accountFilter.getHtmlBuild()}
                     ${this.dateFilter.getHtmlBuild()}
                     ${this.paymentMethodFilter.getHtmlBuild()}
                     ${this.roleFilter.getHtmlBuild()}
                     ${this.currencyFilter.getHtmlBuild()}
                     
                </div>
            </div>
            <div class="w-filters-selected">
                 <div id="filters-selected" class="filters-selected">
                    <div id="selected-accounts"></div>
                    <div id="selected-payment_dates"></div>
                    <div id="selected-roles-overview"></div>
                    <div id="selected-currencies"></div>
                    <div id="selected-payment_methods"></div>
                    <div id="selected-users"></div>
                </div>
            </div>
            <div class="list-header w-justify ">
                <div class="w-left">
                    <button class="btn secondary icon i-export" type="button" data-bind="visible: reportResults().length > 0, event: { click: onClickExport }">Export</button>
                </div>
                <!--
                <div class="w-center">
                    + this.filter.getHtmlBuild()+ 
                </div>
                -->
                 <div class="w-right">
                     ` + this.pagination.getHtmlBuild() + `
                 </div>
            </div>
            
           <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'uniqueName') }, css: { 'list-sort-desc': sortedField()=='uniqueName' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'uniqueName' && orderByDirection() == 'ASC' } ">Name ( loginname )</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'email') }, css: { 'list-sort-desc': sortedField()=='email' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'email' && orderByDirection() == 'ASC' } ">Payment Method ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'paymentMethod') }, css: { 'list-sort-desc': sortedField()=='paymentMethod' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'paymentMethod' && orderByDirection() == 'ASC' } ">Payment Method</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'role') }, css: { 'list-sort-desc': sortedField()=='role' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'role' && orderByDirection() == 'ASC' }    ">Role</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'currency') }, css: { 'list-sort-desc': sortedField()=='currency' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'currency' && orderByDirection() == 'ASC' }  ">Currency</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sumUser') }, css: { 'list-sort-desc': sortedField()=='sumUser' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'sumUser' && orderByDirection() == 'ASC' } ">User total</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'groupCost') }, css: { 'list-sort-desc': sortedField()=='groupCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'groupCost' && orderByDirection() == 'ASC' } ">Total</span></th>

                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'commissionCost') }, css: { 'list-sort-desc': sortedField()=='commissionCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'commissionCost' && orderByDirection() == 'ASC' } ">Commission</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'performanceCost') }, css: { 'list-sort-desc': sortedField()=='performanceCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'performanceCost' && orderByDirection() == 'ASC' } ">Performance</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'consultingBaseCost') }, css: { 'list-sort-desc': sortedField()=='consultingBaseCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'consultingBaseCost' && orderByDirection() == 'ASC' } ">Consulting Base</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'bonusCost') }, css: { 'list-sort-desc': sortedField()=='bonusCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'bonusCost' && orderByDirection() == 'ASC' } ">Bonus</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tipsCost') }, css: { 'list-sort-desc': sortedField()=='tipsCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'tipsCost' && orderByDirection() == 'ASC' } ">Tips</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'hostingCost')}, css: { 'list-sort-desc': sortedField()=='hostingCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'hostingCost' && orderByDirection() == 'ASC' }  ">Hosting</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'trainingCost')}, css: { 'list-sort-desc': sortedField()=='trainingCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'trainingCost' && orderByDirection() == 'ASC' }  ">Training</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'adjustmentsCost')}, css: { 'list-sort-desc': sortedField()=='adjustmentsCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'adjustmentsCost' && orderByDirection() == 'ASC' }  ">Adjustments</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'leadBonusCost')}, css: { 'list-sort-desc': sortedField()=='leadBonusCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'leadBonusCost' && orderByDirection() == 'ASC' }  ">Lead Bonus</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'benefitsCost')}, css: { 'list-sort-desc': sortedField()=='benefitsCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'benefitsCost' && orderByDirection() == 'ASC' }  ">Benefits</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'expensesCost')}, css: { 'list-sort-desc': sortedField()=='expensesCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'expensesCost' && orderByDirection() == 'ASC' }  ">Expenses</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'promotionCost')}, css: { 'list-sort-desc': sortedField()=='promotionCost' && orderByDirection() == 'DESC', 'list-sort-asc': sortedField() == 'promotionCost' && orderByDirection() == 'ASC' }  ">Promotion</span></th>
                        </tr>
                    </thead>
                    <tbody>
                            <tr class="list-grand-total">

                                <td class="align-left" colspan="6"><span>Totals</span></td>
                                <td class="align-right"><span data-bind="text: breakout().grandTotal"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().commissionCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().performanceCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().consultingBaseCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().bonusCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().tipsCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().hostingCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().trainingCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().adjustmentsCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().leadBonusCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().benefitsCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().expensesCost"></span></td>
                                <td class="align-right"><span data-bind="text: breakout().promotionCost"></span></td>
                            </tr>
                    </tbody>
                    <tbody  data-bind="foreach: reportResults()">
                            <tr>
                                    <td><span data-bind="text: uniqueName"></span></td>
                                    <td><span data-bind="text: email"></span></td>
                                    <td><span data-bind="text: paymentMethod"></span></td>
                                    <td><span data-bind="text: role"></span></td>
                                    <td><span data-bind="text: currency"></span></td>
                                    <td class="align-right"><span data-bind="text: sumUser"></span></td>
                                    <td class="align-right"><span data-bind="text: groupCost"></span></td>
                                    <td class="align-right"><span data-bind="text: commissionCost"></span></td>
                                    <td class="align-right"><span data-bind="text: performanceCost"></span></td>
                                    <td class="align-right"><span data-bind="text: consultingBaseCost"></span></td>
                                    <td class="align-right"><span data-bind="text: bonusCost"></span></td>
                                    <td class="align-right"><span data-bind="text: tipsCost"></span></td>
                                    <td class="align-right"><span data-bind="text: hostingCost"></span></td>
                                    <td class="align-right"><span data-bind="text: trainingCost"></span></td>
                                    <td class="align-right"><span data-bind="text: adjustmentsCost"></span></td>
                                    <td class="align-right"><span data-bind="text: leadBonusCost"></span></td>
                                    <td class="align-right"><span data-bind="text: benefitsCost"></span></td>
                                    <td class="align-right"><span data-bind="text: expensesCost"></span></td>
                                    <td class="align-right"><span data-bind="text: promotionCost"></span></td>
                            </tr>
                     </tbody>
                </table>
            </div>
        </div>
            
            `;
    }

    protected initPartial(): void {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.accountFilter = new multipleSelector_template("accountsFilter", this.getTemplateViewModel(), this.caller);
        this.accountFilter.setLabel("Accounts");
        this.accountFilter.setFilterContainerClass('margin-neg');
        this.accountFilter.setTagContainerId('selected-accounts');
        this.accountFilter.setTagContainerCaption('Selected accounts:');

        this.dateFilter = new multipleSelector_template("paymentDatesFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setLabel("Payment Dates");
        this.dateFilter.setFilterContainerClass('margin-neg');
        this.dateFilter.setTagContainerId('selected-payment_dates');
        this.dateFilter.setTagContainerCaption('Selected payment dates:');

        this.paymentMethodFilter = new multipleSelector_template("paymentMethodsFilter", this.getTemplateViewModel(), this.caller);
        this.paymentMethodFilter.setLabel("Payment Methods");
        this.paymentMethodFilter.setFilterContainerClass('margin-neg');
        this.paymentMethodFilter.setTagContainerId('selected-payment_methods');
        this.paymentMethodFilter.setTagContainerCaption('Selected payment methods:');

        this.roleFilter = new multipleSelector_template("rolesFilterOverview", this.getTemplateViewModel(), this.caller);
        this.roleFilter.setLabel("Roles");
        this.roleFilter.setFilterContainerClass('margin-neg');
        this.roleFilter.setTagContainerId('selected-roles-overview');
        this.roleFilter.setTagContainerCaption('Selected roles:');

        this.currencyFilter = new multipleSelector_template("currenciesFilter", this.getTemplateViewModel(), this.caller);
        this.currencyFilter.setLabel("Currencies");
        this.currencyFilter.setFilterContainerClass('margin-neg');
        this.currencyFilter.setTagContainerId('selected-currencies');
        this.currencyFilter.setTagContainerCaption('Selected currencies:');

        this.filterUser = new filterUser_template("filterUser", this.getTemplateViewModel(), this.caller);
        this.filterUser.asMultipleSelectionMode();
        this.filterUser.setTagContainerId('selected-users');
        this.filterUser.setTagContainerCaption('Selected users:');
        this.filterUser.setPlaceholderText("User");

        this.brandMenu = new filterDropdown_template("brandMenu", this.getTemplateViewModel(), this.caller);
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('transactionOverview');
    }

    public formatted(x) {

        return '$' + Number(x).toLocaleString(undefined, {minimumFractionDigits: 2});
    }

    public setPaymentDates(items: any[]){

        let pendingTransactionDate;
        let today = new Date();
        let dateExploded= items[0].datePaid.split(' ')[0].split('-');
        let lastPayment = new Date( dateExploded[0], dateExploded[1], dateExploded[2] );//.split(" ")[0]

        if ( items[0].datePaid.slice(8,10) == 15 )
        {
            //next payment date = Last day of last payment's month
            pendingTransactionDate = new Date(lastPayment.getFullYear(), lastPayment.getMonth(), 0).toISOString().split('T')[0];
        } else
        {
            //next payment date = 15th of current month
            let year, month;

            if ( lastPayment.getMonth() == 12 )
            {
                year = lastPayment.getFullYear()+1;
                month = 1;
            }
            else {
                year = lastPayment.getFullYear();
                month = lastPayment.getMonth();
            }

            pendingTransactionDate = new Date(year, month, 15).toISOString().split('T')[0];
        }

        for (let i=0; i< items.length; i++) {
            items[i].id = Number(items[i].id);
            items[i].name = items[i].datePaid.split(' ')[0];
        }

        let nextId = items[0].id + 1

        items.unshift({id: nextId, name: pendingTransactionDate+" (pending)"})
        console.log(pendingTransactionDate)
        this.getTemplateViewModel().nextPaymentDate(pendingTransactionDate+" 23:59:59");

        this.dateFilter.setItems(items);
        this.dateFilter.setSelectedItems([items[1]]);
    }

    public setBrandFilterItems(options) {

        options.unshift( {id: null, name: 'All'})

        this.brandMenu.setOptions(options);
    }

    public setTransactionAccounts(items){

        this.accountFilter.setItems(items);
    }
    
    public setPaymentRoleFilterItems(items){

        this.roleFilter.setItems(items);
    }

    public setPaymentCurrencyFilterItems(items: any[]){

        items.forEach( currency => {
            currency.name = currency.currency;
        })
        this.currencyFilter.setItems(items);
    }

    public setPaymentMethods(items: any[]){

        items.forEach((item) => {
            if(!isNaN(Number(item.id))){
                item.id = Number(item.id);
            }
        });
        this.paymentMethodFilter.setItems(items);
    }

    public setUsers(users: any[]){

        this.filterUser.setUsers(users);
    }

    protected getTemplateName(): string{
        return "accountingReportByUser-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let that = this;
        return  {

            orderByClause: ko.observable("ORDER BY uniqueName ASC, role ASC, currency ASC")
            ,orderByDirection: ko.observable("ASC")
            ,nextPaymentDate: ko.observable("")
            ,sortedField:  ko.observable("uniqueName")
            ,sortedDESC:  ko.observableArray(["Commission", "Performance", "Consulting Base", "Bonus", "Tips", "Hosting", "Training", "Adjustments", "Lead Bonus", "Benefits", "Expenses", "Promotion"])
            ,breakout:  ko.observableArray([])
            ,reportResults: ko.observableArray([])
            ,reportResultsForExport: ko.observableArray([])
            ,onClickReorder: function (value, data, event) { that.onClickReorder(value, data, event); }
            ,onClickExport: function (data, event) { that.onClickExport(); }
        };
    }

    public formatReportResults(reportResults) {
        let keys;

        if(Object.prototype.toString.call(reportResults) === '[object Object]')
        {
            // Format breakout (totals) fields
            keys = ['grandTotal', 'commissionCost', 'performanceCost', 'consultingBaseCost', 'bonusCost', 'tipsCost', 'hostingCost', 'trainingCost', 'adjustmentsCost', 'leadBonusCost', 'benefitsCost', 'expensesCost', 'promotionCost'];
            keys[0] = 'grandTotal';
            keys.splice(keys.indexOf('groupCost'), 1);
            for (const key of keys) {
                if (reportResults[key] !== undefined) {
                    reportResults[key] = this.formatted(reportResults[key]);
                }
            }
        }
        else {

            keys = ['sumUser', 'groupCost', 'commissionCost', 'performanceCost', 'consultingBaseCost', 'bonusCost', 'tipsCost', 'hostingCost', 'trainingCost', 'adjustmentsCost', 'leadBonusCost', 'benefitsCost', 'expensesCost', 'promotionCost'];

            reportResults.forEach( row => {
                for (let  key of keys) {
                    row[key] = this.formatted(row[key]);
                }
            })
        }

        return reportResults;
    }

    public setReportResults(reportResults) {

        this.getTemplateViewModel().reportResults(this.formatReportResults(reportResults));
    }

    public setReportResultsForExport(reportResultsForExport) {

        this.getTemplateViewModel().reportResultsForExport(this.formatReportResults(reportResultsForExport));
    }

    public setBreakoutData(breakoutData) {

        this.getTemplateViewModel().breakout(this.formatReportResults(breakoutData));
    }

    public getViewModelForRequest() {

        return {
            orderByClause: this.getTemplateViewModel().orderByClause,
            pagination: this.getTemplateViewModel().pagination,
            nextPaymentDate: this.getTemplateViewModel().nextPaymentDate,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'transactionOverview',
            filters: {
                paymentDates: this.getTemplateViewModel().paymentDatesFilter.selectedItems,
                paymentMethods: this.getTemplateViewModel().paymentMethodsFilter.selectedItems,
                roles: this.getTemplateViewModel().rolesFilterOverview.selectedItems,
                currencies: this.getTemplateViewModel().currenciesFilter.selectedItems,
                accounts: this.getTemplateViewModel().accountsFilter.selectedItems,
                users: this.filterUser.getUsersForRequest(),
                //keywords: this.getTemplateViewModel().filter.filterKeyword,
                idBrand: this.getTemplateViewModel().brandMenu.selectedOption() ? this.getTemplateViewModel().brandMenu.selectedOption() : null,
                allBrands: this.getTemplateViewModel().brandMenu.options().slice(1)
            }
        }
    }

    public onClickReorder(value, data, event){

        let direction = data.orderByDirection();
        let columns = [ "uniqueName", "email", "paymentMethod", "role", "currency" ];
        let index = columns.indexOf(value);

        if (index !== -1) {
            columns.splice(index, 1);
        }

        columns.unshift(value);

        if ( value == data.sortedField() )
        {
            if (direction == "ASC") {
                direction = "DESC";
            }
            else {
                direction = "ASC";
            }
        }

        columns[0]+=' '+direction;

        for ( let i=1 ; i < columns.length; i++)
        {
            columns[i] += " ASC";
        }

        let orderByClause = " ORDER BY "+columns.join(", ");

        data.sortedField(value)
        data.orderByClause(orderByClause)
        data.orderByDirection(direction);

        this.caller.filterList(true);
    }

    public onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange();
    }

    public onClickExport() {
        this.caller.getTransactionOverviewForExport()
    }

    public exportToCSV(){

        let data = this.getTemplateViewModel();

        let user = this.getTemplateViewModel().filterUser.user();
        let selectedBrand = this.getTemplateViewModel().brandMenu.selectedOption();
        let fname = "AccountingReportByUser  "+([
            user ? user : "All Users",
            selectedBrand ? selectedBrand.shortName : "All Brands"
        ]).join(' ')+".csv";

        this.caller.exportToCSV(
            data.reportResultsForExport(),
            data.breakout(),
            fname
            );
    }

    public setResultExecutionTime(execTime ){

        this.resultInfos.setExecutionTime(execTime);

    }

    public setResultNbResultsAndPages (nbResults, nbPages) {
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            this.setFilterSelectedItems(this.dateFilter, urlParams.paymentDates);
            this.setFilterSelectedItems(this.paymentMethodFilter, urlParams.paymentMethods);
            this.setFilterSelectedItems(this.roleFilter, urlParams.paymentMethods);
            this.setFilterSelectedItems(this.currencyFilter, urlParams.currencies);
            this.setFilterSelectedItems(this.accountFilter, urlParams.accounts);

            this.getTemplateViewModel().brandMenu.selectedOption(urlParams.idBrand);

            if(urlParams.users) {
                this.filterUser.setSelectedUsersFromRequestParams(urlParams.users);
            } else {
                this.filterUser.resetTagContainer();
            }
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    private setArticlePresetFilter(filterArticle: filterArticle_template, idArticle?: number, title?: string): void {

        filterArticle.getTemplateViewModel().idArticle(idArticle);
        filterArticle.getTemplateViewModel().article(title);
    }

    private setUserPresetFilter(userFilter: filterUser_template, idUser?: number, name?: string): void {

        userFilter.getTemplateViewModel().idUser(idUser);
        userFilter.getTemplateViewModel().user(name);
        userFilter.toggleCloseButton();
    }

    public setDefaults(){

        let dateFilterItems = this.dateFilter.getItems();
        let dateFilterID = dateFilterItems[1].id
        let arrayParam = [];
        arrayParam.push({ id: dateFilterID });
        this.dateFilter.setSelectedItems(arrayParam);
        this.caller.filterList();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/accountingReportByUser_template.ts